/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  set.add(value);
  return set;
}

module.exports = addSetEntry;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-touch/node_modules/lodash/_addSetEntry.js
// module id = ./node_modules/react-touch/node_modules/lodash/_addSetEntry.js
// module chunks = main